{{#if label}}
<label class="field-label" for="{{id}}">
  {{label}}
  {{#if required}}<abbr class="req" title="Required Field">*</abbr>{{/if}}
</label>
{{/if}}
